import React, { useCallback, useState } from 'react';
import { Box, costFormater, FilledDownArrow, RawButton, RightArrowIcon, Text } from '@common-fe/common-fe';
import _ from 'lodash';

import { useGetFundIcon } from '@/modules/investments/hooks';
import { DonutGroupItem } from '@/modules/investments/hooks/useInvestmentsHoldings';

interface Props extends DonutGroupItem {
  isModalMode?: boolean;
}

const InvestmentDonutGroup: React.FC<Props> = ({ isModalMode, title, color, election, value, items }) => {
  const [isExpanded, setExpanded] = useState(false);
  const handleToggle = useCallback(() => {
    setExpanded(!isExpanded);
  }, [isExpanded]);
  const handleGetFundIcon = useGetFundIcon();
  if (isModalMode) {
    return (
      <Box direction="column">
        <Box direction="row" justify="between" align="center">
          <Box direction="row" align="center">
            <div>
              <Box margin={{ right: 'xxs' }} width="8px" height="8px" round="2px" background={color}></Box>
            </div>
            <Text title={title} style={{ flex: '1' }} weight={700} size="medium" truncate>
              {title}
            </Text>
          </Box>
          <Box direction="row">
            <Box justify="start" width={{ min: '42px' }} margin={{ left: 'xxs' }}>
              <Text weight={400}>{`${_.round(election, 1)}%`}</Text>
            </Box>
            <Box width={{ min: '70px' }} margin={{ left: 'xs' }}>
              <Text weight={700}>
                {costFormater(value, {
                  isPrecision: true,
                })}
              </Text>
            </Box>
          </Box>
        </Box>

        {items.map((item) => (
          <Box
            direction="row"
            background="canvas"
            pad="spacing16"
            align="center"
            round="container2Round"
            margin={{ top: 'spacing12' }}
            key={item.key}
          >
            <div>
              {handleGetFundIcon({
                image: item.logo,
                size: '32px',
                isGreyMode: false,
                isNullMode: true,
              })}
            </div>
            <Box fill direction="row" margin={{ left: 'spacing8' }}>
              <Box fill direction="column">
                <Text weight={400} size="large" truncate title={item.title}>
                  {item.title}
                </Text>

                <Text weight={400} color="textSecondary">
                  {item.ticker}
                </Text>
              </Box>
              <div>
                <Box direction="column-reverse" align="end" margin={{ left: 'spacing24' }}>
                  <Box margin={{ left: 'xxs' }}>
                    <Text size="large" weight={400}>{`${_.round(item.election, 1)}%`}</Text>
                  </Box>
                  <Box justify="end" align="end">
                    <Text size="large" weight={700}>
                      {costFormater(_.round(item.value, 1), {
                        isPrecision: true,
                        isOptionalPrecision: true,
                      })}
                    </Text>
                  </Box>
                </Box>
              </div>
            </Box>
          </Box>
        ))}
      </Box>
    );
  }
  return (
    <Box direction="column" width={{ max: '230px' }}>
      <Box direction="row">
        <RawButton onClick={handleToggle}>
          <Box width="16px" height="16px" align="center" justify="center">
            {isExpanded ? (
              <FilledDownArrow color="iconPrimary" size="16px" />
            ) : (
              <RightArrowIcon size="7px" color="iconPrimary" />
            )}
          </Box>
        </RawButton>
        <Box fill direction="row" align="center">
          <div>
            <Box margin={{ right: 'xxs' }} width="8px" height="8px" round="2px" background={color}></Box>
          </div>
          <Text title={title} style={{ flex: '1' }} weight={700} size="medium" truncate>
            {title}
          </Text>
          <Box justify="start" width={{ min: '42px' }} margin={{ left: 'xxs' }}>
            <Text weight={400}>{`${_.round(election, 1)}%`}</Text>
          </Box>
          <Box width={{ min: '70px' }} margin={{ left: 'xs' }}>
            <Text weight={400}>
              {costFormater(value, {
                isPrecision: true,
              })}
            </Text>
          </Box>
        </Box>
      </Box>
      {isExpanded && (
        <>
          {items.map((item) => (
            <Box direction="row" key={item.key}>
              <Box width="16px" />
              <Text weight={400} style={{ flex: 1 }}>
                {item.ticker}
              </Text>
              <Box justify="start" width={{ min: '42px' }} margin={{ left: 'xxs' }}>
                <Text weight={400}>{`${_.round(item.election, 1)}%`}</Text>
              </Box>
              <Box width={{ min: '70px' }} margin={{ left: 'xs' }}>
                <Text weight={400}>
                  {costFormater(_.round(item.value, 1), {
                    isPrecision: true,
                    isOptionalPrecision: true,
                  })}
                </Text>
              </Box>
            </Box>
          ))}
        </>
      )}
    </Box>
  );
};
export default InvestmentDonutGroup;
